import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import type { IAuthorization } from '~/types/authorization'

import { createAuthorizations, getAuthorization, getAuthorizations, updateAuthorization } from '~/api/authorizations'

////////// KEYS //////////

export const keys = {
  all: ['authorizations'] as const,
  details: (authorizationId?: string) => [...keys.all, 'details', authorizationId] as const,
  list: () => [...keys.all, 'list'] as const,
}

////////// QUERIES //////////

export const useAuthorizationsListQuery = (): UseQueryResult<{
  data: IAuthorization[]
  total: number
}> => {
  return useQuery({ queryFn: getAuthorizations, queryKey: keys.list() })
}

export const useAuthorizationDetailsQuery = (authorizationId?: string): UseQueryResult<IAuthorization> => {
  return useQuery({
    enabled: !!authorizationId,
    queryFn: () => getAuthorization(authorizationId as string),
    queryKey: keys.details(authorizationId),
  })
}

////////// MUTATIONS //////////

export const useCreateAuthorizationMutation = (): UseMutationResult<
  IAuthorization[],
  unknown,
  { action: string; description: string; resource: string; service: string }[]
> => {
  return useMutation({ mutationFn: createAuthorizations })
}

export const useUpdateAuthorizationMutation = (): UseMutationResult<
  void,
  unknown,
  { authorizationKey: string; description?: string }
> => {
  return useMutation({ mutationFn: updateAuthorization })
}
